import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import {
  sanitizeUnsafeHTML,
  sanitizeConfigOptions,
} from "@labxchange/util-sanitization";
import { decodeHtmlEntities } from "../utils/stringUtils";
import className from "../style.module.scss";

export function RadioToggle(props) {
  const intl = useIntl();
  return (
    <div>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        htmlFor={props.label}
        className={className.toggleLabel}
        id={props.label}
      >
        <FormattedMessage
          string={props.label}
          sanitizeConfig={sanitizeConfigOptions.LightInlineText}
          description=""
        />
      </label>
      <span
        className={`${className.toggle} ${props.checked ? className.checked : ""}`}
        role="radio"
        aria-checked={props.checked}
        tabIndex={0}
        disabled={props.disabled}
        aria-label={decodeHtmlEntities(
          sanitizeUnsafeHTML(
            intl.formatMessage({
              id: props.label,
              defaultMessage: props.label,
            }),
            sanitizeConfigOptions.PlainText
          )
        )}
        onClick={() => {
          props.onChange();
        }}
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            props.onChange();
          }
        }}
      >
        <span className={className.slider}></span>
      </span>
    </div>
  );
}

RadioToggle.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
